export const truncateString = (text: string, characters = 100) => {
  if (!text || !text.length) return

  if (characters > text.length) return text

  const precut = text.substr(0, characters)

  return text !== precut ? `${precut.slice(0, -1)}…` : precut
}

export const truncateText = (text: string, characters = 100) => {
  if (!text || !text.length) return
  const splitOnChars = ['.', '-', '–', '—', ' ']

  if (characters > text.length) return text

  let precut = text.substr(0, characters)

  while (!splitOnChars.includes(precut.slice(-1)) || precut.length === 0) {
    precut = precut.slice(0, -1)
  }

  return text !== precut ? `${precut.slice(0, -1)}…` : precut
}
